/* contenido de la propuesta seleccionada */

//*react- recursos
//*componentes-utiles
//*clases 
    import ReactTooltip from "react-tooltip";
    import '../../../../css/mdi.css'; 
//*archivos (imagenes y elementos necesarios para la rutina)
//*api's (servicios y store)
//*store's
//*datos
    import etiquetasSSC from "../../../../datos/json/etiquetasSSC.json";
    import articulos from "../../../../datos/json/guidelines.json";
//*funciones
//*interfaces
    interface propsRDPropuesta {
        decisionTextoTodos:any;
        indexPropuesta:any;
        propuesta: any;
    }
//*componente
 export default function RDPropuesta(props: propsRDPropuesta) {  
    //*api store
    //*store's
    //*datos
    //*constantes y variables
        let eti = etiquetasSSC.RD;
    //*useState
    //*useEffect
    //*interface (parametros de entrada)
    //*funciones
    //*vista
     return (
         <>
            {/* contenido propuesta */}
            <div className=" mx-2">
                {/* folio - fecha  */}
                <div className="row ">
                    <div className="col-md-4"><label><span className="color-azul3">{eti.etiquetas[2].text}</span>&nbsp;{props.propuesta.folio}</label></div>
                    <div className="col-md-4"><label><span className="color-azul3">{eti.etiquetas[3].text}</span>&nbsp;{props.propuesta.fecha}</label></div>
                    <div className="col-md-4"><label><span className="color-azul3">{eti.etiquetas[4].text}</span>&nbsp;
                        <i className="mdi mdi mdi-checkbox-marked-circle color-naranja"></i>{props.decisionTextoTodos[props.indexPropuesta]}</label>
                    </div>
                </div>
                {/* proponente del cambio */}
                <div className="row margin-top-1r">
                    <div className="col-md-12 color-azul3">
                        {eti.etiquetas[5].text}<br/>
                        <label className="px-3 color-Gris1 ">
                            <i className="mdi mdi-account  color-azul3"></i>&nbsp;{props.propuesta.user.name}<br/>
                            <i className="mdi mdi-email-check-outline  color-azul3"></i>&nbsp;{props.propuesta.user.email}
                        </label>
                    </div>
                </div>
                {/* descripción */}
                <div className="row margin-top-1r">
                    <div className="col-md-12 color-azul3">
                        {eti.etiquetas[6].text}<br/>
                        <label className="px-3 color-Gris1  ">{props.propuesta.description}</label>
                    </div>
                </div>
                {/* origen del cambio */}
                <div className="row margin-top-1r">
                    <div className="col-md-12 color-azul3">
                        {eti.etiquetas[7].text}
                        <span >
                            <button  id="btnRT2"  data-tip data-for="articulo818"> {eti.etiquetas[7].text2} </button>
                            <ReactTooltip  id="articulo818" type="info"  place="right" multiline >
                                {articulos.hybridArticles[0].ch} <br/><br/>
                                    Articulo: 8<br /> {articulos.hybridArticles[0].art[0].description}<br/><br />
                                    Articulo: 18<br />{articulos.hybridArticles[0].art[1].description}<br/>
                            </ReactTooltip>
                        </span>  
                        <br/>
                        { props.propuesta.origin?.map((o:any, indexP:any) => (
                            (<>
                                <label className="px-3 color-Gris1 ">
                                    <i className="mdi mdi-check color-azul3"></i>&nbsp;{o.name}
                                </label>
                            </>)
                        ))}
                    </div>
                </div>
                {/* procesos que potencialmente serán modificados */}
                <div className="row margin-top-1r">
                    <div className="col-md-12 color-azul3">
                        {eti.etiquetas[8].text}
                        <span >
                            <button  id="btnRT2"  data-tip data-for="articulo818a"> {eti.etiquetas[8].text2} </button>
                            <ReactTooltip  id="articulo818a" type="info"  place="right" multiline >
                                {articulos.hybridArticles[0].ch} <br/><br/>
                                    Articulo: 8<br /> {articulos.hybridArticles[0].art[0].description}<br/><br />
                                    Articulo: 18<br />{articulos.hybridArticles[0].art[1].description}<br/>
                            </ReactTooltip>
                        </span>  
                        <br/>
                        { props.propuesta.processxfrequency?.map((pf:any, indexP:any) => (
                            (<>
                                <label className="px-3 color-Gris1 ">
                                    <i className="mdi mdi-check color-azul3"></i>&nbsp;{pf.acronym} - {pf.processname}
                                </label>
                            </>)
                        ))}
                    </div>
                </div>
            </div>    
         </>
     );
 }

